import type { I18nFn } from 'i18n/types/I18nFn';
import type { SearchFacetData } from 'modules/search/types/SearchFacetData';

export const jobFamilyFacet = (i18n: I18nFn) =>
  ({
    id: 'jobFamilyFacet',
    name: 'synonymId',
    get title() {
      return i18n('Similar Jobs');
    },
    type: 'string',
    options: [],
    optionTitles: {},
    hideInSideFilter: true,
  }) as const satisfies SearchFacetData;
